<template>
    <div>
        <kgr-note-box
            html
            :title-key="`basfi.termsOfUse.v${termsOfUseVersion}.title`"
            :text-key="`basfi.termsOfUse.v${termsOfUseVersion}.text`"
        />
        <kgr-loading v-if="loading" />
        <div v-else>
            <br />
            <div class="kgr-inputGroup">
                <kgr-checkbox
                    v-if="config.termsOfUse !== null"
                    checked
                    disabled
                    :label="$t('basfi.termsOfUse.accepted', {
                        acceptedAt: getDateTime(config.termsOfUse.acceptedAt),
                        acceptedBy: config.termsOfUse.acceptedBy.name,
                    })"
                />
                <kgr-checkbox
                    v-else-if="userMayAcceptTermsOfUse"
                    v-model="basfiCheckboxEnabled"
                    :label="$t('basfi.termsOfUse.checkBoxLabel')"
                />
            </div>

            <div class="kgr-row"></div>
            <div
                v-if="!userMayAcceptTermsOfUse"
                class="kgr-row"
            >
                <kgr-note-box
                    warning
                    text-title="basfi.termsOfUse.userNotAllowed.title"
                    text-key="basfi.termsOfUse.userNotAllowed.text"
                />
            </div>
            <div class="app-formFooter">
                <div class="app-formFooter__hint"></div>
                <div class="app-formFooter__actions">
                    <div class="app-formFooter__action"></div>
                    <div class="app-formFooter__action">
                        <kgr-button
                            v-if="config.termsOfUse === null"
                            :value="$t('basfi.termsOfUse.button.accept')"
                            type="blue"
                            :pending="loading"
                            :disabled="!basfiCheckboxEnabled || !userMayAcceptTermsOfUse"
                            @click="save()"
                        />
                        <kgr-button
                            v-else-if="justAccepted"
                            :value="$t('basfi.termsOfUse.button.goToSettings')"
                            type="blue"
                            @click="goToSettings()"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BasfiFederationConfigRepository from '../../js/repository/BasfiFederationConfigRepository';
import Error from '../../js/model/Error';
import KgrButton from '../../components/common/form/button/KgrButton.vue';
import KgrCheckbox from '../../components/common/form/checkbox/Checkbox.vue';
import KgrNoteBox from '../../components/common/NoteBox.vue';
import Loading from '../../components/common/Loading';
import moment from 'moment';

export default {
    components: {
        'kgr-loading': Loading,
        'kgr-button': KgrButton,
        'kgr-checkbox': KgrCheckbox,
        'kgr-note-box': KgrNoteBox,
    },
    props: {
        federationId: {
            type: Number,
            required: true,
        },
        userMayAcceptTermsOfUse: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            latestTermsOfUseVersion: 1,
            config: null,
            basfiCheckboxEnabled: false,
            loading: false,
            justAccepted: false,
            error: new Error(),
        };
    },
    computed: {
        termsOfUseVersion() {
            if (this.config !== null && this.config.termsOfUse !== null) {
                return this.config.termsOfUse.version;
            }
            return this.latestTermsOfUseVersion;
        },
    },
    created() {
        this.load();
    },
    methods: {
        load(justAccepted) {
            this.loading = true;
            BasfiFederationConfigRepository.find(this.federationId)
                .then((config) => {
                    this.config = config;
                    this.loading = false;
                    this.justAccepted = justAccepted ?? false;
                });
        },
        getDateTime(iso8601dateTime) {
            moment.locale('de');
            return moment(iso8601dateTime).format('LLLL');
        },
        goToSettings() {
            window.location = '/federation/basfi/settings';
        },
        save() {
            if (!this.userMayAcceptTermsOfUse) {
                return;
            }
            this.loading = true;
            BasfiFederationConfigRepository
                .acceptTermsOfUse(this.federationId, this.termsOfUseVersion)
                .then(() => {
                    this.error = new Error();
                    this.$notify.success('saveChanges.success');
                    this.load(true);
                })
                .catch((error) => {
                    this.$notify.error('saveChanges.error');
                    this.error = error;
                })
                .finally(() => this.loading = false);
        },
    },
};
</script>
